import { ProductoService } from './../../../providers/producto.service';
import { Component, Inject, ViewChild, Output, EventEmitter, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { PropuestasService } from '../../../providers/propuestas.service';
import { EntidadService } from '../../../providers/entidad.service';
import { ReplaySubject } from 'rxjs';
import { Entidad, TipoEntidad } from '../../../interfaces/entidad';
import { MatSelect, MatSnackBar, MatHorizontalStepper } from '@angular/material';
import { MatSelectSearchComponent } from '../../mat-select-search/mat-select-search.component';
import { ListarContactosComponent } from '../../../forms/entidad/contactos/listar-contactos/listar-contactos.component';
import { ContactoService } from '../../../providers/contacto.service';
import { Contacto, TipoContacto } from '../../../interfaces/contacto';
import { Telefono } from '../../telefono/telefono.component';
import { VerCotizacionesComponent } from '../../../forms/cotizaciones/ver-cotizaciones/ver-cotizaciones.component';
import { FileHolder } from '../../archivos/image-upload/image-upload.component';
import { ArchivoPropuesta } from '../../../interfaces/archivo-propuesta';
import { CrearActividadDialogComponent } from './crear-actividad-dialog/crear-actividad-dialog.component';
import { VerActividadesComponent } from '../../actividades/ver-actividades/ver-actividades.component';
import { CrearIncidenciaDialogComponent } from './crear-incidencia-dialog/crear-incidencia-dialog.component';
import { VerIncidenciaComponent } from '../../incidencia/ver-incidencia/ver-incidencia.component';
import { UsuarioService } from '../../../providers/usuario.service';
import { Usuario, TipoUsuario, usuarios } from '../../../interfaces/usuario';
import { Data } from '@angular/router';
import { CursoService } from '../../../providers/cursos.service';

export interface DialogData {
  data1: string;
}

interface EstadosPropuesta {
  id: string;
  descripcion: string;
}

interface Producto {
  id: string;
  descripcion: string;
}
interface Curso {
  id: string;
  descripcion: string;
}
interface Workflow {
  id: string;
  descripcion: string;
}
/**
 * @title Dialog Overview
 */
@Component({
  selector: 'app-acciones-propuesta',
  templateUrl: './acciones-propuesta.component.html',
  styleUrls: ['./acciones-propuesta.component.scss'],
})
export class AccionesPropuestaComponent {
  data1: string;

  isEnabled: boolean = false;
  haObtenidoResultado: boolean = false;
  @Output() onCerrado = new EventEmitter();
  @Output() onAccionFinalizada = new EventEmitter();
  @Input() IdProspecto?: number;
  @Output() refreshPage = new EventEmitter();

  constructor(
    public dialog: MatDialog) {
  }
  ngOnInit() {
    // console.log(this.IdProspecto);
    if (this.IdProspecto) {
      this.isEnabled = true;
    }
    // console.log('Disabled',this.isEnabled);
  }

  openDialog(propuesta?): void {
    // console.log('Paso 1');
    // console.log('PROPUESTA', propuesta);
    const dialogRef = this.dialog.open(DialogAccionesPropuesta, {
      width: '70vw',
      data: { propuesta, IdProspecto: this.IdProspecto }
    });
    dialogRef.componentInstance.onCreado.subscribe(() => {
      this.onAccionFinalizada.emit();
      this.refreshPage.emit();
    });
    dialogRef.afterClosed().subscribe(resultado => {
      this.onAccionFinalizada.emit();
    });
  }

}

/**
 * Inicio del Dialog para crear la propuesta
 */

@Component({
  selector: 'dialog-acciones-propuesta',
  templateUrl: 'dialog-acciones-propuesta.html',
  styleUrls: ['acciones-propuesta.component.scss'],
})
export class DialogAccionesPropuesta {

  /**
   * TODO: Mostrar el crear cuando no hay prospectos cargados
   * Revisar si hay que sacar el dialog del mismo ts
   */
  entidad_asociada: string = null;
  accionesContacto: boolean = true;
  entidad: Entidad;
  flujo_actual = 1;
  error: string = '';
  public accion = 'CREAR';
  cargando: boolean;
  public entidadesFiltroCtrl: FormControl = new FormControl();
  public entidadesFiltradas: ReplaySubject<Entidad[]> = new ReplaySubject<Entidad[]>(1);
  public contactosFiltroCtrl: FormControl = new FormControl();
  public contactosFiltradas: ReplaySubject<Contacto[]> = new ReplaySubject<Contacto[]>(1);
  public leyendaTitulo: String = "";
  @ViewChild('selectEntidad') selectEntidad: MatSelect;
  @ViewChild('selectContacto') selectContacto: MatSelect;
  @ViewChild('selectCurso') selectCurso: MatSelect;
  @ViewChild('selectWorkflow') selectworkflow: MatSelect;
  @ViewChild('buscar') searchSelectInput: MatSelectSearchComponent;
  public entidades = [];
  public propuestas: any;
  public editando: boolean = false;
  private debounceTimer: any;
  @ViewChild(ListarContactosComponent) listadoContactos: ListarContactosComponent;
  @ViewChild(VerCotizacionesComponent) verCotizaciones: VerCotizacionesComponent;
  @ViewChild(VerActividadesComponent) listadoActividades: VerActividadesComponent;
  @ViewChild(VerIncidenciaComponent) listadoIncidencias: VerIncidenciaComponent;

  @Output() onEntidadInput = new EventEmitter(); // datos del formulario cambian
  @Output() refreshPage: EventEmitter<any> = new EventEmitter();
  public idPropuesta: number;
  public datos: any;
  public entidadObjeto: Entidad;
  public contacto_propuesta: any;
  public cargandoEntidades: boolean;
  asignacion_usuario: any = {};

  @ViewChild('subirArchivos') subirArchivos: SubirArchivosPropuesta;
  @Output() onCreado = new EventEmitter();
  @ViewChild(MatHorizontalStepper) stepper: MatHorizontalStepper;
  /**
   * Campos del formulario
   */
  formUser = this._formBuilder.group({
    responsables: [],
  });
  form = this._formBuilder.group({
    IdPropuesta: [],
    PropuestaNombre: [null],
    PropuestaObservaciones: [],
    PropuestaImporte: [],
    PropuestaFechaCierreEstimado: [],
    PropuestaFechaCierre: [],
    telefono: [],
    email: [],
    entidad: [null],
    propuesta_estado: [],
    razonsocial: [],
    PropuestaImagen: [],
    producto: [],
    curso: [],
    workflow:[],
    contacto: []
  });
  base64Imagen = [];
  propuesta_id: any;
  datosArchivos: any;
  propuestaEstados: EstadosPropuesta[] = [];
  cargandoEstados: boolean = false;
  productos_select: Producto[] = [];
  curso_select: Curso[] = [];
  workflow_select: Workflow[] = [];
  cargandoProductos: boolean = false;
  IdPropuesta: any;
  usuarios: any = [];
  grupos : any[] = [];
  usuariosSelected: usuarios[] = [];
  tipo: any;
  contactos: Contacto[] = <Contacto[]>[];
  tieneContactoAsig = false;
  isEnabled: boolean = false;
  haObtenidoResultado: boolean = false;
  observacion: any;

  constructor(
    private dialogRef: MatDialogRef<DialogAccionesPropuesta>,
    private _formBuilder: FormBuilder,
    public dialog: MatDialog,
    private _propuestasSv: PropuestasService,
    private productoService: ProductoService,
    private entidadService: EntidadService,
    public snackBar: MatSnackBar,
    private cursoService: CursoService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private usuarioService: UsuarioService,
    public contactoService: ContactoService) {
    // console.log('Paso 2');

  }

  transform(value: any): string {
    return JSON.stringify(value, null, 2);
  }

  traerProductos() {
    this.productos_select = [];
    this.cargandoProductos = true;
    this.productoService.getProductos(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'descripcion',
        order: 'asc'
      },
    ).subscribe( // suscribimos una nueva busqueda
      (respuesta: any) => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.productos) {
          respuesta.data.productos.forEach((producto: any) => {
            this.productos_select.push(
              {
                id: producto.IdProducto,
                descripcion: producto.descripcion,
              })
          });
        }
      },
      () => {
        this.cargandoProductos = false;
      },
      () => {
        this.cargandoProductos = false;
      }
    );
    console.log('Productos', this.productos_select);
  }



  traerWorkflow() {
    this.workflow_select = [];
    this.cargandoProductos = true;
    this._propuestasSv.getFlujos(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'descripcion',
        order: 'asc'
      },
    ).subscribe( // suscribimos una nueva busqueda
      (respuesta: any) => {
        if (respuesta.estado == 1 && respuesta && respuesta.data) {
          respuesta.data.forEach((flujo: any) => {
            this.workflow_select.push(
              {
                id: flujo.id,
                descripcion: flujo.descripcion,
              })
          });
        }
      },
      () => {
        this.cargandoProductos = false;
      },
      () => {
        this.cargandoProductos = false;
      }
    );
    console.log('Aca estan los workflow',  this.workflow_select);
  }



  traerCursos() {
    this.curso_select = [];
    this.cargandoProductos = true;
    this.cursoService.getCursos(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'descripcion',
        order: 'asc'
      },
    ).subscribe( // suscribimos una nueva busqueda
      (respuesta: any) => {
        if (respuesta.estado == 1 && respuesta && respuesta.cursos) {
          respuesta.cursos.forEach((curso: any) => {
            this.curso_select.push(
              {
                id: curso.id,
                descripcion: curso.descripcion,
              })
          });
        }
      },
      () => {
        this.cargandoProductos = false;
      },
      () => {
        this.cargandoProductos = false;
      }
    );
    console.log('Aca estan los cursos',  this.curso_select);
  }
  propuestaArchivar() {
    this.IdPropuesta = {
      IdPropuesta: this.idPropuesta,
      estado: this.form.controls['propuesta_estado'].value
    }
    // console.log(this.IdPropuesta);

    this._propuestasSv.archivarPropuesta(
      this.IdPropuesta
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1) {
          this.dialogRef.close();
          this.snackBar.open("Propuesta archivada correctamente", 'OK', { duration: 2750 });
        }
      }
    );
  }

  verAutomaticos() {
    // console.log("entro");
    this.listadoIncidencias.ver_automaticos = !this.listadoIncidencias.ver_automaticos;
    this.listadoIncidencias.traerIncidencias();
  }

  onNoClick(): void {
    this.onCreado.emit();
    this.dialogRef.close();
  }
  ngOnInit() {
    // console.log('Dialog Data', this.data);
    this.traerProductos();
    this.traerCursos();
    this.traerWorkflow();
    this.getStatus();
    this.tipo = this.data['tipo'];

    if (this.data['propuesta']) {
      let contacto_propuesta = this.data['propuesta'].contacto[0];
      if (contacto_propuesta) {
        this.contacto_propuesta = this.data['propuesta'].contacto[0].IdContacto
        this.form.get('contacto').setValue(contacto_propuesta.IdContacto);
      }
    }
    let contacto_asociado = null;
    //  console.log(this.data, 'data facy');

    if (this.data['propuesta']) {
      let entidad_propuesta = this.data['propuesta'].entidades[0];
      if (entidad_propuesta) {
        this.form.get('entidad').setValue(entidad_propuesta);
        this.entidad_asociada = entidad_propuesta.EntidadRazonSocial;
        this.observacion = entidad_propuesta.EntidadObservacion;
        // console.log('Aca esta la entidad', entidad_propuesta);

      }
    }

    if (this.data['IdProspecto']) {
      let entidad_propuesta = this.data['IdProspecto'];
      if (entidad_propuesta) {
        this.form.get('entidad').setValue(entidad_propuesta);
        this.entidad_asociada = entidad_propuesta.razonSocial;
        //console.log(this.entidad_asociada,'asc');

      }
    }

    this.entidad = new Entidad(); // crear un entidad en blanco



    this.traerEntidades(contacto_asociado);
    this.traerResposables();
    //this.getContactos();
    // cuando cambia el valor del buscador, filtramos
    this.entidadesFiltroCtrl.valueChanges.subscribe(() => {
        this.filtrarEntidades();
    });
    // cuando cambia el valor del buscador, filtramos
    this.contactosFiltroCtrl.valueChanges.subscribe(() => {
      this.filtrarContactos();
    });

    // le decimos al array con filtro como tiene que comparar
    this.entidadesFiltradas.subscribe(
      () => {
        this.selectEntidad.compareWith = (a: Entidad, b: Entidad) => {
          if (a && b) {
            return a.IdEntidad == b.IdEntidad;
          }

          return false;
        }
      }
    );
    if (this.data['propuesta'] != undefined && this.data['propuesta']) {
      /**
       * Editando
      */
      this.datos = this.data['propuesta'];
      // console.log('this.datos', this.datos);

      // console.log('ID pro',this.data['propuesta']);
      // console.log('CURSO ACTUAL VALUE',this.data['IdProspecto']);

      this.cargando = true;
      setTimeout(() => {
        this.cargarEdicion(this.datos);
      }, 100)
      if (this.datos['curso']) {
        this.form.controls['curso'].setValue(this.datos['curso'].id);
      }
      if (this.datos['flujo']) {
        this.form.controls['workflow'].disable();
        this.form.controls['workflow'].setValue(this.datos['flujo'].id);
      }
    }

    if (this.data['IdProspecto']) {
      // this.form.controls['entidad'].setValue({
      //   IdEntidad: this.data['IdProspecto']
      // });
      // this.onContactosChange();
      this.isEnabled = true;
      this.getContactos(this.data['IdProspecto']);
    } else {
      this.getContactos();
    }


    // console.log('CURSO ID', this.form.controls['curso'].value);
    // console.log('CURSO DESC', this.form.controls['curso'].value);
    // console.log('PRODUCTO ID', this.form.controls['producto'].value);
    // console.log('PRODUCTO DESC', this.form.controls['producto'].value);

  }


  traerResposables() {
    this.usuarios = <Usuario[]>[];
    this.usuarioService.getUsuarios(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'nombre',
        order: null
      },
      {
        generico: null
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.usuarios) {
          respuesta.data.usuarios.forEach(usuario => {
            this.usuarios.push(
              new Usuario(
                usuario.id,
                usuario.usuario,
                usuario.email,
                <TipoUsuario>{
                  id: usuario.tipoUsuario.id,
                  descripcion: usuario.tipoUsuario.descripcion
                },
                null,
                usuario.nombre,
                usuario.apellido,
                new Telefono(usuario.telefono.pais, usuario.telefono.area, usuario.telefono.numero),
                +usuario.estado,
                usuario.puesto,
                !!+usuario.editable,
                !!+usuario.eliminable
              )
            );
          });
        }



        // console.log(this.usuarios);
        // console.log(this.form.controls['responsables'].value);
      });
  }

  getGrupos(){
    this.usuarioService.getGrupos(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        order: null
      },
    ).subscribe(
      respuesta => {
        console.log("grupos", respuesta);
        let grupos = [];
        respuesta.data.forEach(element => {
          grupos.push({
            id: element.id,
            descripcion: element.descripcion,
            cantidad_usuarios: element.cantidad,
            usuarios: element.usuarios
          })
        });
        this.grupos = grupos;
      },

      (err) => {

      }
    );
  }


  tieneEntidad(id_entidad): number {

    let res = -1
    for (let i = 0; i < this.entidades.length; i++) {
      if (this.entidades[i].IdEntidad == id_entidad) {
        return i;
      }
    }
    return res;
  }

  checkContacto(event) {
    let contacto = this.form.get('contacto').value;
    // console.log('CONTACTO VALUE', contacto);

    if (contacto.id_entidad) {
      let index = this.tieneEntidad(contacto.id_entidad);
      if (index != -1) {

        this.form.get('entidad').setValue(this.entidades[index]);
        this.leyendaTitulo = "Propuesta " + this.entidades[index].razonSocial;
        this.form.controls['PropuestaNombre'].setValue(this.leyendaTitulo);

        this.tieneContactoAsig = true;

      } else {
        this.form.get('entidad').setValue(null);
        //Seteo el titulo para la propuesta, en este caso va a estar para el contacto
        this.leyendaTitulo = "Propuesta " + contacto.nombre;
        this.form.controls['PropuestaNombre'].setValue(this.leyendaTitulo);

        this.tieneContactoAsig = false;

      }
    } else {
      // this.form.get('entidad').setValue(null);
      //Seteo el titulo para la propuesta, en este caso va a estar para el contacto
      this.leyendaTitulo = "Propuesta " + contacto.nombre;
      this.form.controls['PropuestaNombre'].setValue(this.leyendaTitulo);
      this.tieneContactoAsig = false;

    }
  }

  contactos_traer(search?): void {

    this.contactoService.getContactos(
      {
        page: null,
        pageSize: 50
      },
      {
        sort: null,
        order: null
      },
      {
        mostrar_todo: 1,
        nombre: search
      }
    ).subscribe(
      respuesta => {
        // console.log('CONTACTOS',respuesta);
        if (respuesta.estado == 1 && respuesta.data) {
          this.contactos = respuesta.data.contactos;

        }
      },
      () => {

      }
    );


  }

  getContactos(IdEntidad?): void {

    this.contactoService.getContactos(
      {
        page: null,
        pageSize: 50
      },
      {
        sort: null,
        order: null
      },
      {
        mostrar_todo: 1,
        IdEntidad: IdEntidad
      }
    ).subscribe(
      respuesta => {
        // console.log('CONTACTOS',respuesta);
        if (respuesta.estado == 1 && respuesta.data) {
          this.contactos = respuesta.data.contactos;
          // respuesta.data.contactos.forEach(contacto => {
          //   this.contactos.push(
          //     new Contacto(
          //       contacto.apellido,
          //       contacto.cargo,
          //       contacto.celular,
          //       contacto.email,
          //       <Entidad>{
          //         IdEntidad: contacto.entidad.IdEntidad,
          //         razonSocial: contacto.entidad.razonSocial
          //       },
          //       contacto.examen,
          //       contacto.fechaAlta,
          //       contacto.fechaCertificacion,
          //       contacto.fechaModificacion,
          //       contacto.usuarioModificacion,
          //       contacto.fechaNacimiento,
          //       contacto.fechaUltimaCertificacion,
          //       contacto.idContacto,
          //       contacto.interno,
          //       contacto.kit,
          //       contacto.nombre,
          //       contacto.pago,
          //       contacto.perfil,
          //       contacto.razonSocial,
          //       contacto.telefono,
          // contacto.idContacto,
          // <TipoContacto>{
          //   IdTipoContacto: contacto.tipoContacto.IdTipoContacto,
          //   tipoContactoDesc: contacto.tipoContacto.tipoContactoDesc
          // },
          // )
          // );
          // });
          // console.log(this.contactos, "contactos desde el sv");

        }


      },
      () => {

      }
    );


  }

  userSelected() {
    let aux_user = [];
    // console.log('Aca', this.formUser.controls['responsables'].value);
    this.formUser.controls['responsables'].value.forEach(data => {
      aux_user.push(
        new usuarios(data)
      );
    });
    this.usuariosSelected = aux_user;
    this.asignacion_usuario = {
      'usuarios': this.usuariosSelected,
      'propuesta_id': this.idPropuesta ? this.idPropuesta : '0'
    }
    // console.log('Vomitando for manis', this.asignacion_usuario);
  }

  getStatus() {
    this.propuestaEstados = [];
    this.cargandoEstados = true;
    this._propuestasSv.getEstadosPropuestas({ 'filtros': { 'flujo_id': this.flujo_actual } }).subscribe(
      respuesta => {
        this.cargandoEstados = false;
        if (respuesta.estado == 1) {
          respuesta.estados.forEach((estados: any) => {
            this.propuestaEstados.push({
              id: estados.id,
              descripcion: estados.descripcion,
            });
          });
        }
      },
      error => {
        this.cargandoEstados = false;
      }
    );
  }



  /**
   * Función que sabe como filtrar las entidades
   */
  private filtrarEntidades() {
    if (this.entidadesFiltroCtrl.value.length <= 2) {
      return;
      
    }

     if (this.debounceTimer) {
       clearTimeout(this.debounceTimer);
    }
     this.debounceTimer = setTimeout(() => {
      const search = this.entidadesFiltroCtrl.value;
      // console.log(search);
      this.traerEntidades(search);
      this.entidadesFiltradas.next(this.entidades.slice());
      this.debounceTimer = null;
    }, 600);
    //vER POR QUE LIMPIA EL CAMPO ENTIDAD Y SI CON ESO SE SOLUCIONA EL PROBLEMA DE FONDO
    
  }

  /**
* Función que sabe como filtrar las entidades
*/
  private filtrarContactos() {
    if (this.contactos.length == 0) {
      return;
    }

    // get the search keyword
    let search = this.contactosFiltroCtrl.value;
    if (search != null) {
      //console.log('voy a buscar mas');

      this.contactos_traer(search);
      this.contactosFiltradas.next(this.contactos.slice());
      return;
    } else {
      search = search.toLowerCase();
    }

    // filter the banks
    // this.entidadesFiltradas.next(
    //   this.entidades.filter(entidad => {
    //     return (entidad.razonSocial.toLowerCase().indexOf(search) > -1);
    //   })
    // );
  }

  openDialogCrearActividad() {

    // console.log("id propuest", this.idPropuesta);

    let dialogCrear = this.dialog.open(CrearActividadDialogComponent, {
      disableClose: true,
      data: this.idPropuesta
    });

    dialogCrear.afterClosed().subscribe(resultado => {
      this.listadoActividades.ngOnInit();
    });
  }

  openDialogCrearIncidencia() {
    // console.log(this.contacto_propuesta ,'pro contacto');

    let dialogCrear = this.dialog.open(CrearIncidenciaDialogComponent, {
      disableClose: true,
      data: { idPropuesta: this.idPropuesta, entidad: this.entidadObjeto, contacto: this.contacto_propuesta },
    });

    dialogCrear.afterClosed().subscribe(resultado => {
      this.listadoActividades.ngOnInit();
      this.listadoIncidencias.ngOnInit();
    });
  }


  cargarEdicion(datos) {
    this.editando = true;
    this.accion = 'MODIFICAR';
    this.accionesContacto = true;
    this.form.controls['IdPropuesta'].setValue(datos['IdPropuesta']);
    this.form.controls['PropuestaNombre'].setValue(datos['PropuestaNombre']);
    if (datos['productos'].length > 0) {
      this.form.controls['producto'].setValue(datos['productos'][0]['id']);
    }
    this.form.controls['PropuestaFechaCierreEstimado'].setValue(datos['PropuestaFechaCierreEstimado']);
    this.form.controls['PropuestaImporte'].setValue(datos['PropuestaImporte']);
    this.form.controls['PropuestaObservaciones'].setValue(datos['PropuestaObservaciones']);
    this.form.controls['propuesta_estado'].setValue(datos['PropuestaEstado']);

    if (Object.keys(datos['entidades'][0]).length != 0) {
      this.form.controls['entidad'].setValue({
        IdEntidad: datos['entidades'][0]['IdEntidad'],
      });
      this.traerContactos(datos['entidades'][0]['IdEntidad']);
      this.entidadObjeto = <Entidad>{
        IdEntidad: datos['entidades'][0]['IdEntidad'],
        razonSocial: datos['entidades'][0]['EntidadRazonSocial'],
        tipoEntidad: <TipoEntidad>{
          IdTipo: datos['entidades'][0]['tipo']['IdTipoEntidad'],
          descripcion: datos['entidades'][0]['tipo']['TipoEntidadDesc'],
        }
      }
    }

    this.form.controls['entidad'].disable();
    this.form.controls['propuesta_estado'].disable();
    this.idPropuesta = datos['IdPropuesta'];

    if (Object.keys(datos['entidades'][0]).length != 0) {
      this.tieneContactoAsig = true;
    }

    if (datos['contacto']) {
      this.setContacto(datos['contacto']['IdContacto']);
      this.form.controls['contacto'].disable();
    }

    this.cargando = false;
  }

  setContacto(contacto_id) {
    let index = -1;

    for (let i = 0; i < this.contactos.length; i++) {
      if (this.contactos[i].idContacto == contacto_id) {
        index = i;
        break;
      }
    }

    if (index != -1) {
      this.form.get('contacto').setValue(this.contactos[index]);
    }

  }

  mostrarObservacion() {
    let observacion = '';
    let index = this.tieneEntidad(this.form.get('entidad').value.IdEntidad);
    if (index > 0) {
      observacion = this.entidades[index].observacion;
      if (!observacion) {
        return ''
      }
    }

    return observacion;
  }

  onKey(event: any) { // without type info
  }


  propuestaFinalizada(propuesta, estado) {
    let dilogEditar = this.dialog.open(DialogConfirmarPropuesta, {
      width: '30vw',
      data: { propuesta, estado },
      disableClose: true
    });
    dilogEditar.componentInstance.onFinalizado.subscribe(() => {
      // this.traerPropuestas();
    });
    dilogEditar.afterClosed().subscribe(resultado => {
    });
  }


  /**
   * Carga de la propuesta
   */
  submit() {

    if (this.form.controls['propuesta_estado'].value == 4) {
      this.propuestaFinalizada(this.idPropuesta, this.form.controls['propuesta_estado'].value);
    }
    if(this.data['IdProspecto']){
      this.form.controls['PropuestaNombre'].setValue(this.data['IdProspecto'].razonSocial);
    }
    let prospuesta_formulario = this.form.getRawValue()
    prospuesta_formulario.contacto = { IdContacto: prospuesta_formulario.contacto };
    prospuesta_formulario.entidad = { IdEntidad: prospuesta_formulario.entidad };
    if(this.data['IdProspecto']){     
      prospuesta_formulario.entidad.IdEntidad = this.data['IdProspecto'].IdEntidad;
    }
    this.cargando = true;
    this.error = '';
    try {
      this.propuestas = {
        "propuesta": prospuesta_formulario,
        "asignacion_usuario": this.asignacion_usuario
      }
      // console.log('aca1');

      if (this.form.valid) {
        if (this.propuestas.propuesta.entidad) {
          this.propuestas.propuesta.entidad.contactos = this.entidad.contactos;
        }
        // console.log('aca2');

        this._propuestasSv.generarPropuesta(this.propuestas).subscribe(
          respuesta => {
            this.cargando = false;
            if (respuesta.estado == 1) {
              this.propuesta_id = respuesta.data.propuesta.id;
              this.dialogRef.close();
              this.onInput();
              this.refreshPage.emit();

            } else {
              this.cargando = false;
              this.error = respuesta.mensaje;
              this.onInput();
            }

          },
          error => {
            this.cargando = false;
            this.error = error;
          });
      } else {
        // console.log("formulario no valido");

      }
    } catch (error) {
      this.error = error;
      this.cargando = false;
    }
  }


  onFormState(formState: any): void { // escucha los diferentes estados del formulario
    if (formState.estado && formState.estado != 1) { // ocurrio un error en el formulario
      this.error = formState.mensaje;
    }

    if (typeof formState.cargando != undefined) {
      this.cargando = formState.cargando;
    }
  }

  setCargando(estado) {
    this.cargando = estado;
  }
  /**
   * Traemos las entidades para mostrarlas en la carga
   */
  traerEntidades(filtro): void {
    this.cargandoEntidades = true;
    this.entidades = [];
    this.entidadService.getEntidades(
      {
        page: 0,
        pageSize: 20
      },
      {
        sort: 'razonSocial',
        order: 'asc'
      },
      {
        razonSocial: filtro
      }
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.entidades) {
          this.cargandoEntidades = false;
          // console.log(respuesta.data.entidades);
          this.form.get('entidad').setValue(null);
          respuesta.data.entidades.forEach((prospecto: any) => {
            this.entidades.push(<Entidad>{
              IdEntidad: prospecto.id,
              razonSocial: prospecto.razonSocial,
              email:prospecto.email,
              tipoEntidad: <TipoEntidad>{
                IdTipo: prospecto.tipo.IdTipo,
                descripcion: prospecto.tipo.TipoDescripcion,
              },
              observacion: prospecto.observacion
            });
          });
          // actualizar opciones del filtro
          //this.filtrarEntidades();

        }
      },
      error => {

      }
    );
  }
  traerContactos(IdEntidad: number): void {
    if (IdEntidad) { // si hay un ID
      this.entidad.contactos = [];
      this.listadoContactos.setCargando(true);
      this.contactoService.getContactos(
        {
          page: null,
          pageSize: 50
        },
        {
          sort: 'nombre',
          order: 'asc'
        },
        {
          IdEntidad: IdEntidad
        }
      ).subscribe(
        respuesta => {
          if (respuesta.estado == 1 && respuesta.data && respuesta.data.contactos) {
            respuesta.data.contactos.forEach(contacto => {
              // console.log(respuesta.data.contactos);
              this.entidad.contactos.push(
                new Contacto(
                  contacto.apellido,
                  contacto.cargo,
                  contacto.celularCodigoPais,
                  contacto.celularCodigoArea,
                  contacto.celularNumero,
                  contacto.email,
                  <Entidad>{
                    IdEntidad: contacto.entidad.IdEntidad,
                    razonSocial: contacto.entidad.razonSocial
                  },
                  contacto.examen,
                  contacto.fechaAlta,
                  contacto.fechaCertificacion,
                  contacto.fechaModificacion,
                  contacto.ultimaModificacionPor,
                  contacto.dia_nacimiento,
                  contacto.mes_nacimiento,
                  contacto.fechaUltimaCertificacion,
                  contacto.idContacto,
                  contacto.interno,
                  contacto.kit,
                  contacto.nombre,
                  contacto.pago,
                  contacto.perfil,
                  contacto.razonSocial,
                  contacto.telefonoCodigoPais,
                  contacto.telefonoCodigoArea,
                  contacto.telefonoCodigoNumero,
                  <TipoContacto>{
                    IdTipoContacto: contacto.tipoContacto.IdTipoContacto,
                    tipoContactoDesc: contacto.tipoContacto.tipoContactoDesc
                  },
                )
              );
            });

            this.listadoContactos.setContactos(this.entidad.contactos);
            // console.log(this.entidad.contactos);
          }

          this.listadoContactos.setCargando(false);
        },
        () => {
          this.listadoContactos.setCargando(false);
        }
      );
    }
  }
  onContactosChange() { // si cambia el listado de contactos
    this.entidad.contactos = this.listadoContactos.contactos; // actualizar contactos del entidad
    this.onInput();
  }
  onCursosChange(event: any) {
    // console.log('CURSO SELECT VALUE', this.form.get('curso').value.id);

    // this.entidad.contactos = this.listadoContactos.contactos; // actualizar contactos del entidad
    // this.onInput();

  }
  onInput(): void { // cuando cambia un dato emitimos un evento
    // this.onEntidadInput.emit();
    this.onCreado.emit();
  }
  /**
   * Seteamos el valor por default del titulo de la propuesta
   */
  async onInputLeyenda(event) {
    console.log("Entro a la funcion carajo",event.value);
    this.form.get('contacto').setValue(null);
    this.contactos = null;
    this.tieneContactoAsig = true;

    let target = event.source.selected._element.nativeElement;
    this.leyendaTitulo = "Propuesta " + target.innerText.trim();
    this.form.controls['PropuestaNombre'].setValue(this.leyendaTitulo);
    await this.getContactos(event.value);
    
    this.haObtenidoResultado = true;
  }

  /**
   * Funcion para generar una nueva entidad
   */
  crearEntidad() {
    this.entidades = this.entidades.filter(entidad => {
      return (entidad.IdEntidad != 0);
    });
    let razonsoc = this.entidadesFiltroCtrl.value;
    this.entidades.push(<Entidad>{
      IdEntidad: 0,
      razonSocial: razonsoc,
      tipoEntidad: <TipoEntidad>{
        IdTipo: 1,
        descripcion: "Prospecto"
      }
    });
    this.searchSelectInput._reset();
    this.form.controls['entidad'].setValue({
      IdEntidad: 0,
      razonSocial: razonsoc,
    });
    this.leyendaTitulo = "Propuesta " + razonsoc;
    this.form.controls['PropuestaNombre'].setValue(this.leyendaTitulo);
    // this.selectEntidad.close();
  }
  compareFn(x: Entidad, y: Entidad): boolean {
    return x && y ? x.IdEntidad === y.IdEntidad : x === y;
  }
  actualizarListadoCotizaciones() {
    // this.verCotizaciones.reiniciarPageState();
  }

}

/**
 * Inicio del Dialog para confirmar propuesta
 */

@Component({
  selector: 'dialog-confirmar-propuesta',
  templateUrl: 'dialog-confirmar-propuesta.html',
  styleUrls: ['acciones-propuesta.component.scss'],
})
export class DialogConfirmarPropuesta {
  listadoPropuestas: any[];
  @Output() onFinalizado = new EventEmitter();
  constructor(
    private dialogRef: MatDialogRef<DialogConfirmarPropuesta>,
    private _formBuilder: FormBuilder,
    private _propuestasSv: PropuestasService,
    private entidadService: EntidadService,
    public snackBar: MatSnackBar,
    private propuestaService: PropuestasService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public contactoService: ContactoService
  ) { }
  form = this._formBuilder.group({
    PropuestaObservaciones: []
  })
  ngOnInit() {
    this.traerPropuestas();
  }
  traerPropuestas(): void {
    this.listadoPropuestas = [];
    this.propuestaService.getPropuestas(
      {
        page: null,
        pageSize: null
      },
      {
        sort: null,
        order: null
      },
      {
        generico: '',
        id: this.data['propuesta']
      }
    ).subscribe(
      respuesta => {
        // console.log('Aca', respuesta);
        if (respuesta.estado == 1 && respuesta.data) {
          this.listadoPropuestas = respuesta.data;
          this.form.controls['PropuestaObservaciones'].setValue(this.listadoPropuestas[0].PropuestaObservaciones)
        }
      });
  }

  propuestaFinalizada(situacion) {
    let datos = {
      "IdPropuesta": this.data['propuesta'],
      "estado_id": this.data['estado'],
      "situacion_id": situacion,
      "PropuestaObservaciones": this.form.controls['PropuestaObservaciones'].value,
      "idCliente": localStorage.getItem('idCliente')
    }

    this._propuestasSv.cambiarEstado(datos).subscribe(
      respuesta => {
        this.onFinalizado.emit();
      },
      error => {

      });
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

}
@Component({
  selector: 'dialog-archivar-propuesta',
  templateUrl: 'dialog-archivar-propuesta.html',
  styleUrls: ['acciones-propuesta.component.scss'],
})
export class DialogConfirmarPropuestaArchivada {
  listadoPropuestas: any[];
  tipo: string = '';
  constructor(
    private dialogRef: MatDialogRef<DialogConfirmarPropuesta>,
    private _formBuilder: FormBuilder,
    private entidadService: EntidadService,
    public snackBar: MatSnackBar,
    private propuestaService: PropuestasService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public contactoService: ContactoService
  ) {
    this.tipo = this.data['tipo'];
    // console.log(this.data, "data");

  }
  @Output() onFinalizado = new EventEmitter();
  IdPropuesta: any;
  ocultarPropuesta: boolean[] = [];
  onNoClick(): void {
    this.dialogRef.close();
  }

  propuestaDesarchivar() {
    let datos = {
      'IdPropuesta': this.data['IdPropuesta']
    }
    this.propuestaService.desarchivarPropuesta(
      datos
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1) {
          this.dialogRef.close();
          this.snackBar.open("Propuesta desarchivada correctamente", 'OK', { duration: 2750 });
        }
      }
    );
  }

  propuestaArchivar() {
    // this.IdPropuesta = {
    //   IdPropuesta: this.IdPropuesta,
    //   estado: this.data['estado_']
    // }
    // console.log(this.IdPropuesta);

    let datos = {
      'IdPropuesta': this.data['IdPropuesta']
    }

    this.propuestaService.archivarPropuesta(
      datos
    ).subscribe(
      respuesta => {
        if (respuesta.estado == 1) {

          //resto el contador por estado
          // let propuesta = document.getElementById('propuesta-' + this.data['IdPropuesta'])
          // propuesta.style.display = "none";
          // let mat_list = propuesta.parentNode.childElementCount
          // // let resta = mat_list - 1
          // // propuesta.parentNode.parentNode.firstElementChild.firstElementChild.innerHTML = resta + "";

          this.dialogRef.close();
          this.snackBar.open("Propuesta archivada correctamente", 'OK', { duration: 2750 });
        }
      }
    );
  }

}
@Component({
  selector: 'subir-archivos-propuesta',
  templateUrl: 'subir-archivos-propuesta.html',
  styleUrls: ['acciones-propuesta.component.scss'],
})
export class SubirArchivosPropuesta implements OnInit {
  @Input() propuesta_id?: any;
  archivos: ArchivoPropuesta[] = <ArchivoPropuesta[]>[];
  archivoUploadEstados = [];
  archivoUploadProgressValue: number;
  archivoUploadProgressLimit: number;
  cargando: boolean;
  subir: boolean;
  @Output() onCerrado = new EventEmitter();
  datosArchivos: any;

  constructor
    (
      private propuestaSv: PropuestasService,
      private dialogRef: MatDialogRef<DialogAccionesPropuesta>,
      public snackBar: MatSnackBar,

    ) { }

  ngOnInit() {
    this.cargarArchivo(this.propuesta_id);
  }

  onArchivoCargado(fileHolder: FileHolder): void {
    this.subir = true;
    this.archivos.push(<ArchivoPropuesta>{
      src: fileHolder.src,
      nombre: fileHolder.file.name
    });
  }
  onArchivoQuitado(fileHolder: FileHolder) {
    this.archivos.forEach((archivo: ArchivoPropuesta, index: number) => {
      if (archivo.nombre == fileHolder.file.name && archivo.src == fileHolder.src) {
        this.archivos.splice(index, 1);
      }
    });
    if (this.archivos.length == 0)
      this.subir = false;
  }
  public onSubirArchivos(): void {
    if (this.archivos.length > 0) {
      this.enviarArchivoAlSv(this.archivos[0]);
    }
  }

  enviarArchivoAlSv(archivo: ArchivoPropuesta): void {
    this.cargando = true;
    this.propuestaSv.subirArchivosPropuesta(
      this.propuesta_id.IdPropuesta,
      this.archivos
    ).subscribe(
      respuesta => {
        this.cargando = false;
        if (respuesta) {
          this.archivoUploadEstados.push({
            nombre: archivo.nombre,
            estado: respuesta.estado,
            mensaje: respuesta.mensaje,
            src: archivo.src
          });
          this.snackBar.open(respuesta.mensaje, 'OK', { duration: 2750 });
        }
        this.cargarArchivo(this.propuesta_id);
        // triggereo el boton limpiar
        let element: HTMLElement = document.getElementsByClassName('img-ul-clear')[0] as HTMLElement;
        element.click();
        this.archivos = [];
      },
      error => {
        this.archivoUploadEstados.push({
          nombre: archivo.nombre,
          estado: 2,
          mensaje: error,
          src: archivo.src
        });
        this.snackBar.open(error.mensaje, 'Error', { duration: 2750 });
      }
    );
  }
  cargarArchivo(propuesta_id) {

    this.cargando = true;
    try {
      this.propuestaSv.getArchivoPropuesta(
        {
          "IdPropuesta": propuesta_id.IdPropuesta
        }
      ).subscribe(
        respuesta => {
          this.cargando = false;
          this.datosArchivos = respuesta.data;
        },
        error => {
          this.cargando = false;
          // this.error = error;
        });
    }
    catch (error) {
      // this.error = error;
      this.cargando = false;
    }
  }
  eliminarArchivoPropuesta(datos, archivo_id): void {
    try {
      this.propuestaSv.eliminarArchivoPropuesta(
        {
          "id": archivo_id
        }
      ).subscribe(
        respuesta => {
          this.cargando = false;
          this.snackBar.open(respuesta.mensaje, 'OK', { duration: 2750 });
          this.cargarArchivo(datos);
        },
        error => {
          this.cargando = false;
          // this.error = error;
          this.snackBar.open(error.mensaje, 'OK', { duration: 2750 });
        });
    }
    catch (error) {
      // this.error = error;
      this.cargando = false;
      this.snackBar.open(error.mensaje, 'OK', { duration: 2750 });
    }
  }

}
